package com.swetdot.swetgram.data.premium

import kotlinx.coroutines.flow.StateFlow

data class PremiumBillingOffer(
    val basePlanId: String,
    val formattedRecurringPrice: String,
    val trialAvailable: Boolean,
)

enum class PremiumBillingMessage {
    UNAVAILABLE,
    NO_PURCHASE_FOUND,
    PAYMENT_PENDING,
    VERIFICATION_FAILED,
    ACKNOWLEDGEMENT_PENDING,
    RESTORED,
}

data class PremiumBillingState(
    val connected: Boolean = false,
    val loading: Boolean = true,
    val processing: Boolean = false,
    val offers: List<PremiumBillingOffer> = emptyList(),
    val message: PremiumBillingMessage? = null,
    /** Changes only after the backend has verified a purchase or restore. */
    val verifiedRevision: Long = 0,
)

/** Platform billing UI. It never decides whether Black features are active. */
interface PremiumBilling {
    val state: StateFlow<PremiumBillingState>
    fun startPurchase(basePlanId: String)
    fun restorePurchases()
    fun close()
}
